import type { CSSProperties } from 'react';

/**
 * TanStack `columnDef.meta` for overview-style tables (KIDs v2, NAV-Recon, etc.).
 * Use on column definitions; read in header/cell renderers via `getColumnAlignMeta`.
 */
export interface ColumnAlignMeta {
  align?: 'left' | 'center';
  indent?: boolean;
  width?: string;
  minWidth?: string;
}

export function getColumnAlignMeta(meta: unknown): ColumnAlignMeta | undefined {
  if (meta == null || typeof meta !== 'object') return undefined;
  return meta as ColumnAlignMeta;
}

/** Fixed or minimum column width from meta (for `th` / `td` / `col`). */
export function columnWidthStyle(meta?: ColumnAlignMeta): CSSProperties {
  if (meta?.width) {
    return { width: meta.width, minWidth: meta.width, maxWidth: meta.width };
  }
  if (meta?.minWidth) {
    return { minWidth: meta.minWidth };
  }
  return {};
}
